import { fetchNextJson } from '@iso/lib/nextApiClient';
import {
  isCardsSubscription,
  subscriptionDateTimestamp,
} from '@iso/lib/subscriptionDashboard';

function isMissingPlanName(value) {
  return !String(value || '').trim() || /^n\/a$/i.test(String(value).trim());
}

/** Legacy plans can omit the term and mislabel an active purchase as complete. */
export async function fillMissingSubscriptionPeriods(data, filters, resId) {
  const rows = Array.isArray(data?.byCustomer) ? data.byCustomer : [];
  const ids = [
    ...new Set(
      rows
        .filter(
          (row) =>
            !isCardsSubscription(row) &&
            (subscriptionDateTimestamp(row.end) == null ||
              isMissingPlanName(row.plan_name) ||
              (String(row.status || '').toLowerCase() === 'complete' &&
                subscriptionDateTimestamp(row.end) > Date.now()))
        )
        .map((row) => Number(row.id))
        .filter((id) => Number.isInteger(id) && id > 0)
    ),
  ];
  if (!ids.length) return data;

  const periods = new Map();
  for (let offset = 0; offset < ids.length; offset += 500) {
    const result = await fetchNextJson('/api/reports/subscription-periods', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        purchase_ids: ids.slice(offset, offset + 500),
        restaurant_ids: filters.restaurant_ids?.length
          ? filters.restaurant_ids
          : [resId],
        brand_ids: filters.brand_id || [],
      }),
    });
    if (!result.ok || !result.data?.ok) {
      throw new Error(
        result.data?.error ||
          result.error ||
          'Unable to load subscription periods'
      );
    }
    for (const period of result.data.periods || []) {
      periods.set(String(period.id), period);
    }
  }

  return {
    ...data,
    byCustomer: rows.map((row) => {
      const period = periods.get(String(row.id));
      if (isCardsSubscription(row) || !period) return row;
      return {
        ...row,
        end:
          subscriptionDateTimestamp(row.end) == null &&
          subscriptionDateTimestamp(period.end) != null
            ? period.end
            : row.end,
        plan_name:
          isMissingPlanName(row.plan_name) && period.plan_name
            ? period.plan_name
            : row.plan_name,
        status: period.status || row.status,
      };
    }),
  };
}
